import router from "./router";
import store from "./store";
import { Message } from "element-ui";
import NProgress from "nprogress"; // Progress 进度条
import "nprogress/nprogress.css"; // Progress 进度条样式
import { getToken } from "@/utils/auth"; // 验权
import { checkToken } from "@/api/auth";
import { getResources } from "@/utils/auth";

const whiteList = ["/login", "/loginRedirect", "/report", "/report/exam", "/register"]; // 不重定向白名单
router.beforeEach((to, from, next) => {
  NProgress.start();
  if (['/activityStatistics/hd1', '/activityStatistics/hd2', '/activityStatistics/hd2e', '/activityStatistics/hd3', '/activityStatistics/hd3e'].includes(to.path)) {
    store.dispatch("HideMenu");
  } else {
    store.dispatch("ShowMenu");
  }

  if (to.path === '/login' && !to.query.ft) {
    to.query.ft = 'wpc';
    next(to);
    NProgress.done();
    return;
  }
  if (getToken()) {
    if (to.path === '/login' || to.name === 'Platform.Login') {
      let loginRoute = JSON.parse(JSON.stringify({
        name: to.name,
        path: to.path,
        query: to.query,
        params: to.params,
      }))
      if (loginRoute.query.redirectRoute) {
        delete loginRoute.query.redirectRoute
      }
      let loginRouteJson = localStorage.getItem('loginRoute')
      if (loginRouteJson === JSON.stringify(loginRoute)) {
        next({
          path: '/'
        })
      } else {
        next()
      }
      NProgress.done(); // if current page is dashboard will not trigger	afterEach hook, so manually handle it
    } else if (whiteList.indexOf(to.path) !== -1 || to.name === 'Platform.Login') {
      next();
      NProgress.done();
    } else {
      //每次页面跳转的时候都验证token有效性
      checkToken(!from.matched.length)
        .then(() => {
          if (!store.getters['websocket/ws']) {
            store.commit('websocket/webSocketInit');
          }
          if (
            !store.getters.async_routers ||
            store.getters.async_routers.length === 0
          ) {
            store
              // .dispatch("flushRoutesView")
              .dispatch("generateRoutes", getResources())
              .then(() => {
                if (
                  store.getters.async_routers &&
                  store.getters.async_routers.length > 0
                ) {
                  router.addRoutes(store.getters.async_routers); // 动态添加可访问路由表
                  next({ ...to, replace: true });
                } else {
                  next();
                }
              })
              .finally(() => {
                NProgress.done();
              });
          } else {
            next();
            NProgress.done();
          }
        })
        .catch(() => {
          store.dispatch("clearAccessInfo").then(() => {
            store.dispatch("clearRoutes").then(() => {
              Message.error("会话已失效，请重新登录");
              next({ path: "/" });
            });
          });
        });
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1 || to.name === 'Platform.Login') {
      next();
      NProgress.done();
    } else {
      let redirectRoute = JSON.stringify({
        name: to.name,
        path: to.path,
        query: to.query,
        params: to.params,
      })
      let nextRoute = {}
      if (localStorage.getItem('loginRoute')) {
        try {
          nextRoute = JSON.parse(localStorage.getItem('loginRoute'))
        } catch (e) {
          nextRoute = {
            path: '/login'
          }
        }
      } else {
        nextRoute = {
          path: '/login'
        }
      }
      if (!nextRoute.query) {
        nextRoute.query = {}
      }
      nextRoute.query.redirectRoute = redirectRoute
      next(nextRoute)

      NProgress.done();
    }
  }
});

router.afterEach(() => {
  NProgress.done(); // 结束Progress
});
